import {
  Box as MuiBox,
  Button,
  styled,
  css,
  buttonClasses,
} from "@mui/material";

const Box = styled(MuiBox)`
  &.button-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 40px;

    &.small-text {
      font-size: 30px;
    }
  }
`;

const CustomButton = styled(Button)<{ selected?: boolean }>`
  &.${buttonClasses.disabled} {
    color: #bbbbbb;
    background: #f1f1f1;
    border: solid 1px #dee2ec;
  }

  border-color: #f1f1f1 !important;
  color: black;
  font-size: 3vw;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1) !important;
  padding: 2%;
  width: 46%;

  ${({ selected }) =>
    selected &&
    css`
      background: #f3f8ff !important;
      color: #2c62f6;
      border: solid 1px #2c62f6 !important;
    `}
`;

interface DialButtonProps {
  text: string;
  onClick: () => void;
  selected?: boolean;
  disabled?: boolean;
  sx?: Record<string, any>;
}

export const DialButton = ({
  text,
  onClick,
  selected,
  disabled,
  sx,
}: DialButtonProps) => {
  return (
    <CustomButton
      onClick={onClick}
      variant="outlined"
      disabled={disabled}
      selected={selected}
      sx={sx}
    >
      <Box className={`button-text ${text.length > 6 ? "small-text" : ""}`}>
        {text}
      </Box>
    </CustomButton>
  );
};
